export default "__VITE_ASSET__BTSk8niZ__"